$(document).ready(function () {
  var openDecscription = function () {
    if ($(".cpb-product-actions").length == 0) {
      return false;
    }
    $("#js-cpb-custom-desc").removeClass("cpb-custom-hide");
    $(".cpb-add-to-cart-button").on("click", function () {
      var maxStep = 30;
      var checkLoading = function () {
        maxStep--;
        if (maxStep <= 0) return true;
        if ($(".cpb-loading").length == 0) return false;
        $("#js-cpb-custom-desc").addClass("cpb-custom-hide");
        return true;
      };
      var addToCartTimer = setInterval(function () {
        if (checkLoading()) {
          clearInterval(addToCartTimer);
        }
      }, 100);
    });
    return true;
  };
  var timer = setInterval(function () {
    if (openDecscription()) {
      clearInterval(timer);
    }
  }, 300);
});
//temp for fix bugs
(function ($) {
  $(function () {
    // var workTest = function () {
    //   var $builder = $("#product-builder");
    //   $builder.on("mouseenter", ".cpb-option-type-img  span", function () {
    //     console.log("mouseenter", this);
    //   });
    //   $builder.on("mouseleave", ".cpb-option-type-img  span", function () {
    //     console.log("mouseleave", this);
    //   });
    //   console.log("tooltrip", $(".cpb-option-type-img span"));
    // };
    //////////////////////
    var CpbApp = {
      $builder: null,
      selectors: {
        tabs: ".react-tabs__tab",
        nextTabBtn: ".cpb-product-actions .cpb-next-tab-button",
        resetBtn: ".cpb-product-actions .cpb-reset-button",
        container: ".cpb-panels-container",
      },
    };
    CpbApp.init = function () {
      this.$builder = $("#product-builder");
      var app = this;
      var checkTabs = function () {
        setTimeout(function () {
          app.checkTabs();
        }, 10);
      };
      this.$builder.on("click", this.selectors.nextTabBtn, checkTabs);
      this.$builder.on("click", this.selectors.tabs, checkTabs);
      this.checkTabs();
    };
    CpbApp.checkTabs = function () {
      var app = this;
      var $tabs = app.$builder.find(app.selectors.tabs);
      var activeNumber = -1;
      $tabs.each(function (index, elem) {
        if ($(elem).hasClass("cpb-active")) {
          activeNumber = index;
          return false;
        }
      });
      console.log("activeNumber", activeNumber);
      if (activeNumber + 1 == $tabs.length) {
        app.$builder
          .find(app.selectors.container)
          .addClass("cpb-summary-panel");
      } else {
        app.$builder
          .find(app.selectors.container)
          .removeClass("cpb-summary-panel");
      }
    };
    //temporary add to cart scroll

    var addToCartFix = function () {
      //scroll fix
      $("#product-builder").on("click", ".cpb-add-to-cart-button", function () {
        setTimeout(function () {
          if ($(".cpb-loader-center").length == 0) return;
          $("html, body").animate(
            {
              scrollTop: $("#product-builder").offset().top,
            },
            100
          );
        }, 100);
      });
    };

    //end temporary add to cart scroll

    var cpbLoaded = function () {
      if ($(".cpb-product-actions").length > 0) {
        CpbApp.init();
        // workTest();
        addToCartFix();
      } else {
        window.requestAnimationFrame(cpbLoaded);
      }
    };
    cpbLoaded();
    //temp

    //};
  });
})(jQuery);

// Creating Tooltips for iOS devices
function tooltips() {
  if (iOS()) {
    $(".cpb-option-type-img").each((i, option) => {
      const optionId = option.dataset.optionId;

      let tooltipContent = option.textContent;

      let optionObjFromCPB;

      CPB.getStore()
        .getState()
        .Product.panels.find((panel) =>
          panel.categories.find((category) =>
            category.options.find((option) => {
              if (option.id === optionId) {
                optionObjFromCPB = option;
              }
            })
          )
        );

      const optionPrice = optionObjFromCPB.price;

      tooltipContent += " " + Shopify.formatMoney(optionPrice);

      tippy(option, {
        content: tooltipContent,
        trigger: "click",
        zIndex: 10,
        placement: "bottom",
        flipOnUpdate: true,
        boundary: "window",
      });
    });
  }

  function iOS() {
    var iDevices = [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }
}

var cpbLoaded = function () {
  if (jQuery(".cpb-option").length > 0) {
    tooltips();
  } else {
    window.requestAnimationFrame(cpbLoaded);
  }
};

cpbLoaded();
